<template>
  <a-pagination
    show-quick-jumper
    class="custom-pagination"
    :total="totalCount"
    v-model="currentPage"
    :page-size.sync="pageSize"
    :show-total="total => `共 ${total} 条`"
    @change="handlePageChange"
    @showSizeChange="handlePerPageChange"
  />
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    totalCount: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.perPage
      },
      set(val) {
        this.$emit('update:perPage', val)
      }
    }
  },
  watch: {
    totalCount(val) {
      // 最后一页数据被删除，自动跳到上一页
      const totalPages = this.$lodash.ceil(val / this.pageSize)
      if (this.page > 1 && totalPages < this.page) {
        this.handlePerPageChange(totalPages, this.perPage)
      }
    }
  },
  methods: {
    handlePageChange(page, perPage) {
      this.$emit('change', { page: page, per_page: perPage })
    },

    handlePerPageChange(page, perPage) {
      // ant design 会自动计算页数，还未同步到 page，主动同步
      this.$emit('update:page', page)
      this.$emit('change', { page: page, per_page: perPage })
    }
  }
}
</script>

<style lang="less" scoped>
.custom-pagination {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
  color: #fff;

  /deep/ .ant-pagination-options-quick-jumper input {
    width: 80px;
  }
}
</style>
